import { Heading, HeadingProps, useColorModeValue } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export interface IPageTitleProps extends HeadingProps {
    children: string;
    pageTitle?: string;
    notSetPageTitle?: boolean;
}

export function PageTitle({ children, pageTitle, notSetPageTitle, ...headingProps }: IPageTitleProps) {
    const { t } = useTranslation();

    // t is a dep so the document title refreshes when the language changes
    useEffect(() => {
        if (notSetPageTitle) {
            return;
        }

        const title = pageTitle === undefined ? children : pageTitle;
        if (title === "" || title === undefined) {
            document.title = t("app.name");
        } else {
            document.title = `${title} / ${t("app.name")}`;
        }
    }, [children, pageTitle, notSetPageTitle, t]);

    return (
        <Heading
            fontSize="3xl"
            fontWeight={"semibold"}
            color={useColorModeValue("brand.500", "brand.400")}
            {...headingProps}
        >
            {children}
        </Heading>
    );
}
